import React from "react";
import { Container, Typography, Paper, Divider, Box } from "@mui/material";

export default function TnC() {
  // Detect which page: terms or privacy
  const isPrivacy = window.location.pathname.includes("privacy");
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>
          {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ mt: 2 }}>
          {/* Existing content starts here */}
          <Typography variant="body1">
            Terms & Conditions of Use: <br />
            It’s is a BETA release of this website and all the other software
            applications / products listed and accessible through this website.
            Please be vigilant while using this website and transacting. You may
            report us any usability issue you may encounter through our standard
            ‘Contact us” options.<br />
            This website and related SOFTWARE IS PROVIDED( accessed through this
            website or directly accessed by other channels )"AS IS", WITHOUT WARRANTY
            OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
            THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
            OTHER DEALINGS IN THE SOFTWARE. <br />
            <br />Your use of the OmneVu.com and services and tools (referred to as
            “OmneVu.com” or “Platform” throughout this document) are governed by
            the following terms and conditions ("Terms of Use" or “Terms &
            Conditions” or “Terms & conditions of use”) as applicable to the
            Platform including the applicable policies which are incorporated herein
            by way of reference. If You access and/or transact on the Platform, You
            shall be subject to the policies that are applicable to the Platform for
            such access or transaction. By mere use of the Platform, You shall be
            contracting with Digilytics Systems LLP and these terms and conditions
            including the policies constitute Your binding obligations, with
            OmneVu.com. <br />
            <br />The website www.omnevu.com ("OmneVu") is operated by Digilytics
            Systems LLP ("OmneVu" or "us" or "we" or "our"), having its registered
            office located 5, Prabhas, Sahahakar Nagar-2, Pune, Maharastra, India.
            Please read the Conditions of Use document carefully before using the
            OmneVu.com website. By using the OmneVu.com website, you signify your
            agreement to be bound by OmneVu.com’s Terms of Use. <br />
            Please read these conditions carefully before using the OmneVu.com
            website. By using the OmneVu.com website, you signify your agreement to
            be bound by these conditions. <br />
            In addition, when you use any current or future OmneVu.com service, you
            will also be subject to the terms, guidelines and conditions applicable
            to that OmneVu.com. <br />
            These "Terms of Use" constitute an electronic record within the meaning
            of the applicable law. This electronic record is generated by a computer
            system and does not require any physical or digital signatures. <br />
            <br />ACCESSING, BROWSING OR OTHERWISE USING THE SITE INDICATES YOUR
            AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO
            PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING. By impliedly
            or expressly accepting these Terms of Use, You also accept and agree to
            be bound by Digilytics Systems LLP’s Policies ((including but not
            limited to Privacy Policy) as amended from time to time<br />
            <br />Terms of Use Relating to Your Use of OmneVu.com<br />
            1. Your Account and Registration<br />
            <br />If You use the Platform, You shall be responsible for maintaining
            the confidentiality of your Display Name and Password and You shall be
            responsible for all activities that occur under your Display Name and
            Password. You agree that if You provide any information that is untrue,
            inaccurate, not current or incomplete or We have reasonable grounds to
            suspect that such information is untrue, inaccurate, not current or
            incomplete, or not in accordance with the this Terms of Use, We shall
            have the right to indefinitely suspend or terminate or block access of
            your membership on the Platform and refuse to provide You with access to
            the Platform. <br />
            <br />Your mobile phone number and/or e-mail address is treated as Your
            primary identifier on the Platform. It is your responsibility to ensure
            that Your mobile phone number and your email address is up to date on
            the Platform at all times. You agree to notify Us promptly if your
            mobile phone number or e-mail address changes by updating the same on
            the Platform through a onetime password verification. <br />
            <br />You agree that Digilytics Systems LLP shall not be liable or
            responsible for the activities or consequences of use or misuse of any
            information that occurs under your Account in cases, including, where You
            have failed to update Your revised mobile phone number and/or e-mail
            address on the Website Platform.
            <br />If You share or allow others to have access to Your account on the
            Platform (“Account”), by creating separate profiles under Your Account,
            or otherwise, they will be able to view and access Your Account
            information. You shall be solely liable and responsible for all the
            activities undertaken under Your Account, and any consequences there
            from.
            You must maintain confidentiality of the account information and for all
            the activities that occur under Your account. You must not share your
            login details, ie, username and password of Your account with any other
            person, else it would be considered breach of this Terms of Use.
            <br />You agree to: (a) ensure that You successfully log out from Your
            account at the end of each session; and (b) immediately notify Digilytics
            Systems LLP of any unauthorized use of Your account. If there is reason
            to believe that there is likely to be a breach of security or misuse of
            Your account, We may request You to change the password or we may
            suspend Your account without any liability to Digilytics Systems LLP,
            for such period of time as we deem appropriate in the circumstances. We
            shall not be liable for any loss or damage arising from Your failure to
            comply with this provision.
            <br />You will have access to other apps owned by Digilytics Systems LLP
            and other group companies through the same login username and password.
            You agree to have single login access to all the apps owned by Digilytics
            Systems LLP and other group companies. <br />
            2. Communication
            <br />When You use the Platform or send emails or other data, information
            or communication to us, You agree and understand that You are
            communicating with Us through electronic records and You consent to
            receive communications via electronic records from Us periodically and
            as and when required. We may communicate with you by email or by such
            other mode of communication, electronic or otherwise. <br />
            You agree, understand and acknowledge that the website is an online
            platform that enables you to purchase products listed on the website at
            the price indicated therein at any time from any location. You further
            agree and acknowledge that OmneVu.com is only a facilitator and is not
            and cannot be a party to or control in any manner for any transactions
            with listed third parties on the website. Accordingly, the
            agreement/contract of sale of products on the website shall be a
            strictly bipartite agreement/contract between you and the sellers on
            OmneVu.com. <br />
            3. Access to OmneVu.com<br />
            We will do our utmost to ensure that availability of the website will be
            uninterrupted and that transmissions will be error-free. However, due to
            the nature of the Internet, this cannot be guaranteed. Also, your access
            to the website may also be occasionally suspended or restricted to allow
            for repairs, maintenance, or the introduction of new facilities or
            services at any time without prior notice. We will attempt to limit the
            frequency and duration of any such suspension or restriction. <br />
            4. Licence for website access<br />
            Subject to your compliance with these Terms of Use and payment of
            applicable fees, if any, Digilytics Systems LLP grants you a limited
            licence to access and make personal use of this website, but not to
            download (other than page caching) or modify it, or any portion of it,
            except with express written consent of Digilytics Systems LLP and / or
            its affiliates, as may be applicable. This licence does not include any
            resale or commercial use of this website or its contents; any collection
            and use of any product listings, descriptions, or prices; any derivative
            use of this website or its contents; any downloading or copying of
            account information for the benefit of another seller; or any use of data
            mining, robots, or similar data gathering and extraction tools. <br />
            This website or any portion of this website (including but not limited to
            any copyrighted material, trademarks, or other proprietary information)
            may not be reproduced, duplicated, copied, sold, resold, visited,
            distributed or otherwise exploited for any commercial purpose without
            express written consent of Digilytics Systems LLP and / or its
            affiliates, as may be applicable. <br />
            You may not frame or use framing techniques to enclose any trademark,
            logo, or other proprietary information (including images, text, page
            layout, or form) of OmneVu.com and its affiliates without express
            written consent. You may not use any meta tags or any other "hidden
            text" utilising Digilytics Systems LLP's or its affiliates' names or
            trademarks without the express written consent of Digilytics Systems
            LLP and / or its affiliates, as applicable. Any unauthorised use
            terminates the permission or license granted by Digilytics Systems LLP
            and / or its affiliates, as applicable. <br />
            5. Your Conduct<br />
            You must not use the website in any way that causes, or is likely to
            cause, the website or access to it to be interrupted, damaged or impaired
            in any way You understand that you, and not OmneVu.com, are responsible
            for all electronic communications and content sent from your computer to
            us and you must use the website for lawful purposes only. You must not
            use the website for any of the following: <br />
            • for fraudulent purposes, or in connection with a criminal offense or
            other unlawful activity<br />
            • to send, use or reuse any material that does not belong to you; or is
            illegal, is offensive (including but not limited to material that is
            sexually explicit content or which promotes racism, bigotry, hatred or
            physical harm), deceptive, misleading, abusive, indecent, invasive of
            another's privacy, including bodily privacy, insulting or harassing on
            the basis of gender, blasphemous, defamatory, libelous, obscene,
            pornographic, paedophilic, or menacing; racially or ethnically
            objectionable, or disparaging; in breach of copyright, trademark, patent,
            confidentiality, privacy or any other proprietary information or right;
            or is otherwise injurious to third parties or relates to or promotes
            money laundering or gambling or promotes enmity between different groups
            on the grounds of religion or caste with the intent to incite violence;
            or is harmful to minors in any way; or impersonates another person; or
            threatens the unity, integrity, defence, security or sovereignty of India
            or friendly relations with foreign States or public order or causes
            incitement to the commission of any cognisable offence or prevents
            investigation of any offence or is insulting other nation; or objectionable
            or otherwise unlawful in any manner whatsoever; or which consists of or
            contains software viruses or any other computer code, file or program
            designed to interrupt, destroy or limit the functionality of any computer
            resource, political campaigning, commercial solicitation, chain letters,
            mass mailings or any spam.<br />;.
            • to deceive or mislead the addressee about the origin of messages. <br />
            6. Reviews, comments, communications and other content<br />
            Users of this website may comments and other content; send communications;
            and submit suggestions, ideas, comments, questions, or other information,
            as long as the content does / is not illegal, offensive (including but
            not limited to material that is sexually explicit content or which
            promotes racism, bigotry, hatred or physical harm), deceptive, misleading,
            abusive, indecent, invasive of another's privacy, including bodily
            privacy, insulting or harassing on the basis of gender, blasphemous,
            defamatory, libelous, obscene, pornographic, paedophilic or menacing;
            racially or ethnically objectionable, or disparaging; in breach of
            copyright, trademark, patent, confidentiality, privacy or any other
            proprietary information or right; or otherwise injurious to third
            parties or relates to or promotes money laundering or gambling, or
            promotes enmity between different groups on the grounds of religion or
            caste with the intent to incite violence; or is harmful to minors in any
            way, or impersonates another person; or threatens the unity, integrity,
            defence, security or sovereignty of India or friendly relations with
            foreign States or public order or causes incitement to the commission of
            any cognisable offence or prevents investigation of any offence or is
            insulting other nation; or objectionable or otherwise unlawful in any
            manner whatsoever; or which consists of or contains software viruses or
            any other computer code, file or program designed to interrupt, destroy
            or limit the functionality of any computer resource, political campaigning,
            commercial solicitation, chain letters, mass mailings or any spam; or
            deceive or mislead the addressee about the origin of messages. In the
            event a user fails to comply with the above. Digilytics Systems LLP
            reserves the right (but not the obligation) to remove, refuse, delete or
            edit any content that in the sole judgement of Digilytics Systems LLP
            violates these Conditions of use and, or terminate your permission to
            access or use this website. <br />
            If you do post content or submit material to this site and/or various
            applications accessible through this website, and unless we indicate
            otherwise, you<br />
            a. grant Digilytics Systems LLP and its affiliates a non-exclusive,
            royalty-free, irrevocable, perpetual and fully sublicensable rights to
            use, reproduce, modify, adapt, publish, translate, create derivative
            works from, distribute, and display such content throughout the world in
            any media; and<br />
            b. Digilytics Systems LLP and its affiliates and sublicensees the right
            to use the name that you submit in connection with such content, if they
            choose. <br />
            You agree that the rights you grant above are irrevocable during the
            entire period of protection of your intellectual property rights
            associated with such content and material. You agree to waive your right
            to be identified as the author of such content and your right to object
            to derogatory treatment of such content. You agree to perform all further
            acts necessary to perfect any of the above rights granted by you to
            Digilytics Systems LLP, including the execution of deeds and documents,
            at its request. <br />
            You represent and warrant that you own or otherwise control all of the
            rights to the content that you post or that you otherwise provide on or
            through the website; that, as at the date that the content or material
            is submitted to OmneVu.com: (i) the content and material is accurate;
            (ii) use of the content and material you supply does not breach any
            applicable OmneVu.com policies or guidelines and will not cause injury
            to any person or entity (including that the content or material is not
            defamatory); (iii) the content is lawful. You agree to indemnify
            Digilytics Systems LLP and its affiliates for all claims brought by a
            third party against it or its affiliates arising out of or in connection
            with a breach of any of these warranties. <br />
            Product images shown on the website are only indicative in nature. They
            do not prescribe or conform to any standards and/or actual product
            specifications and/or colour scheme and/or schematics and/or drawings
            and/or any other attribute. You should take a required precaution before
            making any buying / referring / reviewing or any other decisions based
            on details showed. <br />
            7. Claims against Objectionable Content<br />
            You can refer to the product detail page on OmneVu.com for checking any
            product details provided by the seller regarding the total price / break
            up price, Description of goods and other key details which may be useful
            to user to make right decisions. <br />
            8. Copyright, authors' rights and database rights <br />
            All content included on the website, such as text, graphics, logos, button
            icons, images, audio clips, digital downloads, data compilations, and
            software, is the property of Digilytics Systems LLP, its affiliates or
            its content suppliers and is protected by India and international
            copyright, authors' rights and database right laws. The compilation of
            all content on this website is the exclusive property of Digilytics
            Systems LLP and its affiliates and is protected by laws of India and
            international copyright and database right laws. All software used on
            this website is the property of Digilytics Systems LLP, its affiliates or
            its software suppliers and is protected by India and international
            copyright and author' rights laws. <br />
            You may not systematically extract/ or re-utilise parts of the contents of
            the website without Digilytics Systems LLP and / or its affiliate's (as
            may be applicable) express written consent. In particular, you may not
            utilise any data mining, robots, or similar data gathering and extraction
            tools to extract (whether once or many times) for re-utilisation of any
            substantial parts of this website, without Digilytics Systems LLP and /
            or its affiliate's (as may be applicable) express written consent. You
            may also not create and/ or publish your own database that features
            substantial (eg: prices and product listings) parts of this website
            without Digilytics Systems LLP and / or its affiliate's (as may be
            applicable) express written consent. <br />
            9. Intellectual Property Claims
            Digilytics Systems LLP and its affiliates respect the intellectual
            property of others. If you believe that your intellectual property rights
            have been used in a way that gives rise to concerns of infringement,
            write us an email at info@OmneVu.com with a subject line as “Intellectual
            Property Right Claim” and email body clearly mentioning your Name,
            Address, Contact Number, contact email id, claim attachment – PDF format
            (duly digitally signed) highlighting your ownership of the contents /
            intellectual property rights. Our teams will pick up your notice on
            priority for right action. <br />
            10. Disclaimer <br />
            You acknowledge and undertake that you are accessing the services on the
            website and transacting at your own risk and are using your best and
            prudent judgment before entering into any transactions through the
            website. You further acknowledge and undertake that you will use the
            website to order products only for your personal use. We shall neither be
            liable nor responsible for any actions or inactions of sellers nor any
            breach of conditions, representations or warranties by the sellers or
            manufacturers of the products andneither be liable nor responsible for
            any actions or inactions of sellers nor any breach of conditions,
            representations or warranties by the sellers or manufacturers of the
            products nor hereby expressly disclaim and any all responsibility and
            liability in that regard. We shall not mediate or resolve any dispute or
            disagreement between you and the sellers or manufacturers of the products.
            <br />
            We further expressly disclaim any warranties or representations (express
            or implied) in respect of quality, suitability, accuracy, reliability,
            completeness, timeliness, performance, safety, merchantability, fitness
            for a particular purpose, or legality of the products listed or displayed
            or transacted or the content (including product or pricing information
            and/or specifications) on the website. While we have taken precautions
            to avoid inaccuracies in content, this website, all content, information
            (including the price of products), software, products, services and
            related graphics are provided as is, without warranty of any kind. We do
            not implicitly or explicitly support or endorse the sale or purchase of
            any products on the website. At no time shall any right, title or
            interest in the products sold through or displayed on the website vest
            with Digilytics Systems LLP nor shall Digilytics Systems LLP have any
            obligations or liabilities in respect of any transactions on the website.
            <br />
            11. Indemnity and Release<br />
            You shall indemnify and hold harmless Digilytics Systems LLP, its
            subsidiaries, affiliates and their respective officers, directors, agents
            and employees, from any claim or demand, or actions including reasonable
            attorney's fees, made by any third party or penalty imposed due to or
            arising out of your breach of these Terms and Conditions of Use or any
            document incorporated by reference, or your violation of any law, rules,
            regulations or the rights of a third party. <br />
            You hereby expressly release Digilytics Systems LLP and/or its affiliates
            and/or any of its officers and representatives from any cost, damage,
            liability or other consequence of any of the actions/inactions of the
            vendors and specifically waiver any claims or demands that you may have
            in this behalf under any statute, contract or otherwise. <br />
            12. Membership Eligibility and Children<br />
            Transaction on the Platform is available only to persons who can form
            legally binding agreements / contracts under Indian Contract Act, 1872.
            Persons who are "incompetent to contract" within the meaning of the
            Indian Contract Act, 1872 including un-discharged insolvents etc. are
            not eligible to use theis Platform. <br />
            Anyone with a legal age of less than 18years is advised not to use this
            website. <br />
            13. Other Businesses<br />
            Parties including Digilytics Systems LLP and its affiliates may operate
            stores, provide services, or sell product lines on OmneVu.com. In
            addition, we provide links to the websites of affiliated companies,
            knowledge /news portals and certain other businesses. We are not
            responsible for examining or evaluating, and we do not warrant or endorse
            the offerings and/or information and/or contents of any of these
            businesses or individuals, or the content of their websites. Digilytics
            Systems LLP does not assume any responsibility or liability for the
            actions, products, and content of any of these and any other third-parties.
            You can tell when a third-party is involved in your transactions, and we
            may share customer information related to those transactions with that
            third-party. You should carefully review their privacy statements and
            other conditions of use. <br />
            14. Losses<br />
            We will not be responsible for any business loss (including loss of
            profits, revenue, contracts, anticipated savings, data, goodwill or wasted
            expenditure) or any other indirect or consequential loss that is not
            reasonably foreseeable to both you and us when you commenced initiate
            using/browsing/searching thise website. <br />
            15. Alteration of Service or Amendments to the Conditions<br />
            We reserve the right to make changes to our website, policies, and these
            Terms and Conditions of Use / Privacy Policies / Return policies at any
            time. You will be subject to the policies and Conditions of Use / Privacy
            Policies / Return policies in force at the time that you use the website
            or that you order goods from / through us., unless any change to those
            policies or these conditions is required to be made by law or government
            authority (in which case it will apply to orders previously placed by
            you). If any of these conditions is deemed invalid, void, or for any
            reason unenforceable, that condition will be deemed severable and will
            not affect the validity and enforceability of any remaining condition. <br />
            16. Events beyond our reasonable control<br />
            While we endeavour to provide you with best of the services in our
            capacity, Wwe will not be held responsible for any delay or failure to
            comply with our obligations under these conditions if the delay or
            failure arises from any cause which is beyond our reasonable control.
            This condition does not affect your statutory rights. <br />
            17. Waiver<br />
            If you breach these conditions and we take no action, we will still be
            entitled to use our rights and remedies in any other situation where you
            breach these conditions. <br />
            18. Governing law and Jurisdiction<br />
            These conditions are governed by and construed in accordance with the laws
            of India. You agree, as we do, to submit to the exclusive jurisdiction of
            the courts at Pune.
            19. Our Details<br />
            This website is operated by Digilytics Systems LLP. <br />
            For the OmneVu.com website, you could contact us by visiting:
            https://www.OmneVu.com/ContactUs.through contact details available on
            our website (www.OmneVu.com) or through an email to us at omnevu@gmail.com.
            <br />
            20. Use of the OmneVu.com and related Software<br />
            You may use OmneVu.com and related Software (called as OmneVu.com software
            henceforth) solely for purposes of enabling you to use and enjoy the
            Services as provided by OmneVu.com Software, and as permitted by the Terms
            & Conditions of Use/Privacy Policy and these OmneVu Software Terms and any
            Terms. You may not incorporate any portion of the OmneVu Software into your
            own programs or compile any portion of it in combination with your own
            programs, transfer it for use with another service, or sell, rent, lease,
            lend, loan, distribute or sub-license the OmneVu.com Software or otherwise
            assign any rights to the OmneVu.com Software in whole or in part. You may
            not use the OmneVu.com Software for any illegal purpose. We may cease
            providing any OmneVu.com Software and we may terminate your right to use
            any OmneVu.com Software at any time. Your rights to use the OmneVu.com
            Software will automatically terminate without notice from us if you fail
            to comply with any of these OmneVu.com Software Terms, the Terms &
            Conditions of Use or any other Terms. Additional third party terms
            contained within or distributed with certain OmneVu.com Software that are
            specifically identified in related documentation may apply to that
            OmneVu.com and will govern the use of such software in the event of a
            conflict with these Terms & Conditions of Use. All software used in any
            OmneVu.com is the property of Digilytics Systems LLP and/or its affiliates
            or its software suppliers and protected by laws of India. <br />
            21. Use of Third Party Services<br />
            When you use the OmneVu.com Software, you may also be using the services
            of one or more third parties, such as a wireless carrier, open source
            software / libraries, licensed proprietary software or modules or a mobile
            platform provider or open source libraries. Your use of these third party
            services may be subject to the separate policies, terms of use, and fees
            of these third parties. <br />
            22. No Reverse Engineering and use of Automated Bots<br />
            You may not, and you will not encourage, assist or authorize any other
            person to copy, modify, reverse engineer, decompile or disassemble, or
            otherwise tamper with, the OmneVu.com website and Software, whether in
            whole or in part, or create any derivative works from or of the OmneVu.com
            website and Software. You will not use or assist to use or recommend to
            use any automated bots and/or programs for web scrapping, data gathering,
            testing, sampling or any other purpose(s) which may use / involve / impact
            OmneVu.com website / software in any manner. <br />
            25. Pricing and availability<br />
            We list availability information for products or services sold by us on the
            website, including on each product or service selection or on information
            page. Beyond what we say on that page or otherwise on the website, we
            cannot be more specific about availability. Please note that dispatch
            estimates are just indicative. They are not guaranteed dispatch times and
            should not be relied upon as such. As we process your order, you will be
            informed by e-mail if any products you order turn out to be unavailable.
            <br />
            Disclaimer: Pricing on any product(s) or service(s) as is reflected on the
            Platform may due to some technical issue, typographical error or product
            information published by seller may be incorrectly reflected and in such
            an event seller may cancel such your order(s). <br />
            1. You release and indemnify Digilytics Systems LLP and/or any of its
            directors and officers and representatives from any cost, damage, liability
            or other consequence of any of the actions of the Users of the Platform
            and specifically waive any claims that you may have in this behalf under
            any applicable law. Notwithstanding its reasonable efforts in that
            behalf, Digilytics Systems LLP cannot take responsibility or control the
            information provided by other Users which is made available on the Platform.
            You may find other User's information to be offensive, harmful,
            inconsistent, inaccurate, or deceptive. Please use caution and practice
            safe trading when using the Platform. <br />
            Please note that there could be risks in dealing with underage persons or
            people acting under false pretence. <br />
            Charges: <br />
            Digilytics Systems LLP may charge a nominal fee for browsing and/or buying
            on the Platform. Digilytics Systems LLP reserves the right to change its
            Fee Policy from time to time. In particular, Digilytics Systems LLP may
            at its sole discretion introduce new services/fees and modify some or all
            of the existing services/fees offered on the Platform. In such an event,
            Digilytics Systems LLP reserves the right to introduce fees for the new or
            existing services offered or amend/introduce fees for existing/new services,
            as the case may be. Changes to the Fee Policy shall be posted on the
            Platform and such changes shall automatically become effective immediately
            after they are posted on the Platform. Unless otherwise stated, all fees
            shall be quoted in Indian Rupees. You shall be solely responsible for
            compliance of all applicable laws including those in India for making
            payments to Digilytics Systems LLP. <br />
            What is the platform fee?
            Fee levied by OmneVu.com to sustain the efficient operations and continuous
            improvement of the platform, for a hassle-free app experience. <br />
            26. Health & Safety<br />
            By purchasing any product from our website, you acknowledge that you have
            read and understood our Health & Safety Guidelines. <br />
            27. Alteration or Amendments to the Conditions<br />
            We reserve the right to make changes to our policies, and these Conditions
            of Sale at any time. You will be subject to the policies and Conditions of
            Sale in force at the time you order goods from us, unless any change to
            those policies or these conditions is required to be made by law or
            government authority (in which case it will apply to orders previously
            placed by you). If any of these conditions is deemed invalid, void, or for
            any reason unenforceable, that condition will be deemed severable and will
            not affect the validity and enforceability of any remaining condition. <br />
            28. Events beyond our reasonable control<br />
            We will not be held responsible for any delay or failure to comply with our
            obligations under these conditions if the delay or failure arises from any
            cause which is beyond our reasonable control. This condition does not
            affect your statutory rights. <br />
            29. Waiver<br />
            If you breach these conditions and we take no action, we will still be
            entitled to use our rights and remedies in any other situation where you
            breach these conditions. <br />
            30. Disclaimer of Warranties and Liability<br />
            This Platform, all the materials and products (including but not limited to
            software) and services, included on or otherwise made available to You
            through this site are provided on "as is" and "as available" basis without
            any representation or warranties, express or implied except otherwise
            specified in writing. Without prejudice to the forgoing paragraph,
            OmneVu.com does not warrant that: <br />
            This Platform will be constantly available, or available at all; or
            The information on this Platform is complete, true, accurate or
            non-misleading. <br />
            Digilytics Systems LLP will not be liable to You in any way or in relation
            to the Contents of, or use of, or otherwise in connection with, the
            Platform. Digilytics Systems LLP does not warrant that this site;
            information, Content, materials, product (including software) or services
            included on or otherwise made available to You through the Platform;
            their servers; or electronic communication sent from Us are free of viruses
            or other harmful components. <br />
            Nothing on Platform constitutes, or is meant to constitute, advice of any
            kind. All the Products sold on Platform are governed by different state
            laws and if Seller is unable to deliver such Products due to implications
            of different state laws, Seller will return or will give credit for the
            amount (if any) received in advance by Seller from the sale of such Product
            that could not be delivered to You. <br />
            Trademark, Copyright and Restriction<br />
            This site is controlled and operated by Digilytics Systems LLP and products
            are sold by respective Sellers. All material on this site, including images,
            illustrations, audio clips, and video clips, are protected by copyrights,
            trademarks, and other intellectual property rights. Material on Platform is
            solely for Your personal, non-commercial use. You must not copy, reproduce,
            republish, upload, post, transmit or distribute such material in any way,
            including by email or other electronic means and whether directly or
            indirectly and You must not assist any other person to do so. Without the
            prior written consent of the owner, modification of the materials, use of
            the materials on any other Platform or networked computer environment or use
            of the materials for any purpose other than personal, non-commercial use
            is a violation of the copyrights, trademarks and other proprietary rights,
            and is prohibited. Any use for which You receive any remuneration, whether
            in money or otherwise, is a commercial use for the purposes of this clause.
            <br />
            Privacy Policy –
            Privacy Policy:<br />
            By using OmneVu.com website and services you agree to our use of your
            personal information (including sensitive personal information) in
            accordance with this Privacy Notice, as may be amended from time to time
            by us at our discretion. You also agree and consent to us collecting,
            storing, processing, transferring, and sharing your personal information
            (including sensitive personal information) with third parties or service
            providers for the purposes set out in this Privacy Notice. <br />
            We may automatically collect and store certain types of information about
            your use of OmneVu.com and it’s services, including information about your
            interaction with content and services available through OmneVu.com. We may
            use cookies and other unique identifiers, and we obtain certain types of
            information when your web browser or device accesses OmneVu.com and it’s
            services and other content served by or on behalf of OmneVu.com on other
            websites. <br />
            We might receive information about you from other sources, such as updated
            delivery and address information from our carriers, which we use to correct
            our records and deliver your next purchase more easily. <br />
            We use your personal information to operate, provide, develop, and improve
            the products and services that we offer our customers. These purposes
            include: <br />
            • We may use your personal information to take and fulfill orders, deliver
            products and services, process payments, and communicate with you about
            orders, products and services, and promotional offers. <br />
            • We may use your personal information to provide functionality, analyze
            performance, fix errors, and improve the usability and effectiveness of the
            OmneVu.com Services. <br />
            • We may use your personal information to recommend features, products, and
            services that might be of interest to you, identify your preferences, and
            personalize your experience with OmneVu.com / Services. <br />
            • In certain cases, we may collect and use your personal information to
            comply with laws. <br />
            • We may use your personal information to communicate with you in relation
            to OmneVu.com and it’s associated product(s) and/or services via different
            channels (e.g., by phone, e-mail, chat). <br />
            • We may use your personal information to display interest-based ads for
            features, products, and services that might be of interest to you. <br />
            • We may use personal information to prevent and detect fraud and abuse in
            order to protect the security of our customers, OmneVu.com, and others. <br />
            To enable our systems to recognize your browser or device and to provide
            and improve OmneVu.com Services, we use cookies and other identifiers. <br />
            Third-Party Advertisers and Links to Other Websites: OmneVu.com may include
            third-party advertising and links to other websites and apps. Third-party
            advertising partners may collect information about you when you interact
            with their content, advertising, and services. <br />
            Third Party software:
            Use and declarations related to Third party software Libraries and Software:
            <br />
            To enable a seamless browsing experience to our customers, we rely on using
            the third party libraries and software. These third party libraries and
            software are governed by their own usage policies, declarations and privacy
            policies. Your use of ReUrja.com website automatically mandates you to
            follow the terms and conditions, governing rules / regulations,
            declarations, privacy policies etc. applicable under these Third party
            libraries and software. You may find the details of these at the below
            listed links. <br />
            Third party software libraries and/or components Terms, Privacy policies,
            license references: <br />
            • https://mui.com/ , https://mui.com/legal/,<br />
            • https://github.com/remix-run/react-router, https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme,<br />
            • https://github.com/dozoisch/react-google-recaptcha?tab=MIT-1-ov-file#readme,<br />
            • https://www.svgrepo.com/page/licensing/,<br />
            • React - https://github.com/facebook/react/blob/main/LICENSE<br />
            • Xlsx - https://github.com/SheetJS/sheetjs?tab=Apache-2.0-1-ov-file#readme,<br />
            • React router dom - https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme,<br />
            • Uuid - https://github.com/uuidjs/uuid?tab=MIT-1-ov-file#readme,<br />
            • Nanoid - https://github.com/ai/nanoid?tab=MIT-1-ov-file#readme,<br />
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

